import React from 'react'
import PropTypes from 'prop-types'
import { ProfileImageBase } from './components/ProfileImageBase'
import { ProfileChangeImageModal } from './components/ProfileChangeImageModal'

/**
 * A profile picture that opens a dialog to change it.
 *
 * The dialog has two tabs: pick one of the avatars the backend offers, or upload and crop your
 * own. `type` renders one of them without the tab strip.
 */


export const ProfileImage = React.memo((
  {
    item, nameField = 'name', urlField = 'img', imageTitle, image, isRounded, noShadow, isDisabled, noBorder, noTitle, children, isLoading,// ProfileImageBase Props
    modalTitle, modalSize, modalBoxSize, closeModalOnSubmit,//modal Props
    callback, type, addTabs, getUserPermissionToUploadImage, getImage, //ProfileChangeImageModal Props
    uploadImageAction, aspect,//Upload Image with crop Props
    checkForAgencyToChooseAvatar, avatarImageGroupKey, avatarsData, chooseAvatarAction, chooseAvatarLoading, disableAgencyIcon = true, imagesGap, //Choose avatar Props
    isUploadImageEnabled,isChooseAvatarEnabled
  }) => {
  /*
   * Chakra's `useDisclosure` is three lines of state with a name. Only open/close/isOpen were
   * used, so it is written out rather than kept as a reason to depend on Chakra.
   */
  const [isOpen, setIsOpen] = React.useState(false)
  const onOpen = () => setIsOpen(true)
  const onClose = () => setIsOpen(false)

  return <div>
    <ProfileImageBase
      isLoading={isLoading}
      isDisabled={isDisabled}
      item={item}
      onOpen={onOpen}
      isOpen={isOpen}
      onClose={onClose}
      imageTitle={imageTitle}
      nameField={nameField}
      urlField={urlField}
      isRounded={isRounded}
      noShadow={noShadow}
      image={image}
      noBorder={noBorder}
      noTitle={noTitle}
      children={children}
    />
    <ProfileChangeImageModal
      loading={chooseAvatarLoading}
      item={item}
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      callback={callback}
      modalTitle={modalTitle}
      type={type}
      addTabs={addTabs}
      getUserPermissionToUploadImage={getUserPermissionToUploadImage}
      imageField={urlField}
      defaultImage={image}
      uploadImageAction={uploadImageAction}
      getImage={getImage}
      aspect={aspect}
      isRounded={isRounded}
      size={modalSize}
      boxSize={modalBoxSize}
      checkForAgencyToChooseAvatar={checkForAgencyToChooseAvatar}
      avatarImageGroupKey={avatarImageGroupKey}
      avatarsData={avatarsData}
      chooseAvatarAction={chooseAvatarAction}
      isUploadImageEnabled={isUploadImageEnabled}
      isChooseAvatarEnabled={isChooseAvatarEnabled}
      closeModalOnSubmit={closeModalOnSubmit}
      disableAgencyIcon={disableAgencyIcon}
      imagesGap={imagesGap}
    />
  </div>
})

ProfileImage.displayName = 'ProfileImage'

ProfileImage.propTypes = {
  item: PropTypes.object,
  nameField: PropTypes.string,
  urlField: PropTypes.string,
  imageTitle: PropTypes.node,
  image: PropTypes.string,
  isRounded: PropTypes.bool,
  noShadow: PropTypes.bool,
  noBorder: PropTypes.bool,
  noTitle: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  /** Render function for a custom layout: `({ AvatarImage, item, onOpen, isOpen, onClose })`. */
  children: PropTypes.func,
  modalTitle: PropTypes.node,
  modalSize: PropTypes.string,
  modalBoxSize: PropTypes.string,
  closeModalOnSubmit: PropTypes.bool,
  callback: PropTypes.func,
  /** `'default'` shows both tabs; `'upload'` or `'chooseAvatar'` renders that one alone. */
  type: PropTypes.string,
  addTabs: PropTypes.array,
  getUserPermissionToUploadImage: PropTypes.func,
  getImage: PropTypes.func,
  uploadImageAction: PropTypes.func,
  /** `1` for a square, `16 / 9` for landscape. */
  aspect: PropTypes.number,
  checkForAgencyToChooseAvatar: PropTypes.bool,
  avatarImageGroupKey: PropTypes.string,
  avatarsData: PropTypes.array,
  chooseAvatarAction: PropTypes.func,
  chooseAvatarLoading: PropTypes.bool,
  disableAgencyIcon: PropTypes.bool,
  imagesGap: PropTypes.string,
  isUploadImageEnabled: PropTypes.bool,
  isChooseAvatarEnabled: PropTypes.bool
}
